// extracted by mini-css-extract-plugin
export var addButton = "_as-0";
export var border = "_as-8";
export var check = "_as-h";
export var danger = "_as-6";
export var dropdownContainer = "_as-1";
export var editModalBody = "_as-j";
export var footerContainer = "_as-i";
export var fullWidth = "_as-a";
export var hide = "_as-9";
export var icon = "_as-3";
export var input = "_as-7";
export var inputFlex = "_as-b";
export var inputWrapper = "_as-c";
export var manualFocus = "_as-5";
export var optionButton = "_as-4";
export var pillWrapper = "_as-e";
export var pointer = "_as-2";
export var showOverflow = "_as-f";
export var tagsFlex = "_as-d";
export var xButton = "_as-g";